/*
 * this method clears all inflight payment related data (the card details retrieved by getInflightPaymentDetails, the
 * cardSubmissionSession and the paymentIds.) Leaving the session free to allow a new card to be added. If no options
 * are passed in to specify which data to clear, all are cleared
 */
import actions from '@ehi/global-marketing-interface/lib/actions';
import GMI from 'constants/gmiConstants';

export const removeInflightPaymentDetails = (passedOpts) => (dispatch) => {
  let opts = { payment: true, cardSubmissionUrl: true, paymentIds: true };

  // this action might be passed to change handlers directly so this guards against event object being misinterpreted as options
  if (passedOpts && !passedOpts.nativeEvent) {
    opts = passedOpts;
  }

  opts.payment && dispatch(actions.deleteGmiState(GMI.STATE.GMA.RESERVATION.PAYMENT));
  opts.cardSubmissionUrl && dispatch(actions.deleteGmiState(GMI.STATE.GMA.RESERVATION.CARD_SUBMISSION_SESSION));
  opts.paymentIds && dispatch(actions.reservations.commitState.unset('payment_ids'));
};
